import React from "react";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./NavigationButton.css";



const NavigationButton = ({ direction, message, page, passFunction }) => {

  let displayButton;
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  if (direction === "next") {
    displayButton = (
      <div>
        <span className="btn-inner--text">{t("regular.next")}</span>
        <span className="btn-inner--icon mr-1">
          <FontAwesomeIcon icon={faChevronRight} />
        </span>
      </div>
    )
  } else if (direction === "back") {
    displayButton = (
      <div>
        <span className="btn-inner--icon mr-1">
          <FontAwesomeIcon icon={faChevronLeft} />
        </span>
        <span className="btn-inner--text">{t("regular.back")}</span>
      </div>
    )
  } else {
    displayButton = <span className="btn-inner--text">{message}</span>;
  }

  const manageClick = () => {
    if (passFunction) {
      passFunction()
    }
    navigate("/" + page)
  }

  const variantClass = direction === "back" ? "lesson-nav-btn--back" : "lesson-nav-btn--next";

  return (

    <Button className={`btn-icon lesson-nav-btn ${variantClass}`} type="button" onClick={manageClick}>
      {displayButton}
    </Button>

  );
};

export default NavigationButton;
